/* Iron Lion — theme.js · minimal, dependency-free, accessible */
(function () {
  "use strict";

  /* --- mobile nav drawer (accessible dialog) --- */
  var toggle = document.querySelector("[data-nav-toggle]");
  var drawer = document.querySelector("[data-mobile-drawer]");
  if (toggle && drawer) {
    var panel = drawer.querySelector(".mobile-drawer__panel");
    var mainContent = document.getElementById("MainContent");
    var siteFooter = document.querySelector(".site-footer");
    var lastFocus = null;
    var FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function trapFocus(e) {
      if (e.key !== "Tab") return;
      var items = Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE));
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function open() {
      lastFocus = document.activeElement;
      drawer.setAttribute("aria-hidden", "false");
      toggle.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
      if (mainContent) mainContent.inert = true;
      if (siteFooter) siteFooter.inert = true;
      drawer.addEventListener("keydown", trapFocus);
      var f = panel.querySelector(FOCUSABLE);
      if (f) f.focus();
    }

    function close(returnFocus) {
      drawer.setAttribute("aria-hidden", "true");
      toggle.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
      if (mainContent) mainContent.inert = false;
      if (siteFooter) siteFooter.inert = false;
      drawer.removeEventListener("keydown", trapFocus);
      if (returnFocus !== false && lastFocus) lastFocus.focus();
    }

    toggle.addEventListener("click", open);
    drawer.addEventListener("click", function (e) {
      var t = e.target.closest("[data-drawer-close], .mobile-drawer__scrim");
      if (!t) return;
      var isLink = t.tagName === "A" && t.getAttribute("href");
      close(isLink ? false : true);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer.getAttribute("aria-hidden") === "false") close();
    });
  }

  /* --- live cart count + accessible label --- */
  function refreshCart() {
    fetch("/cart.js", { headers: { "Content-Type": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        document.querySelectorAll("[data-cart-link]").forEach(function (el) {
          el.setAttribute("aria-label", "Cart, " + cart.item_count + " items");
        });
      })
      .catch(function () {});
  }
  refreshCart();
  document.addEventListener("cart:updated", refreshCart);

  /* --- cart drawer (AJAX add-to-cart) --- */
  var cartDrawer = document.querySelector("[data-cart-drawer]");
  if (cartDrawer) {
    var cartPanel = cartDrawer.querySelector(".cart-drawer__panel");
    var cartMain = document.getElementById("MainContent");
    var cartSiteFooter = document.querySelector(".site-footer");
    var cartLastFocus = null;
    var CART_FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var FREE_SHIP_THRESHOLD = 7500; /* cents, matches main-cart.liquid */

    function cartTrapFocus(e) {
      if (e.key !== "Tab") return;
      var items = Array.prototype.slice.call(cartPanel.querySelectorAll(CART_FOCUSABLE));
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function openCartDrawer() {
      cartLastFocus = document.activeElement;
      cartDrawer.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      if (cartMain) cartMain.inert = true;
      if (cartSiteFooter) cartSiteFooter.inert = true;
      cartDrawer.addEventListener("keydown", cartTrapFocus);
      var f = cartPanel.querySelector(CART_FOCUSABLE);
      if (f) f.focus();
    }

    function closeCartDrawer(returnFocus) {
      cartDrawer.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      if (cartMain) cartMain.inert = false;
      if (cartSiteFooter) cartSiteFooter.inert = false;
      cartDrawer.removeEventListener("keydown", cartTrapFocus);
      if (returnFocus !== false && cartLastFocus) cartLastFocus.focus();
    }

    function money(cents) {
      return "$" + (cents / 100).toFixed(2);
    }

    function escapeHtml(str) {
      var div = document.createElement("div");
      div.textContent = str == null ? "" : String(str);
      return div.innerHTML;
    }

    function renderCartDrawer(cart) {
      var body = cartDrawer.querySelector("[data-cart-drawer-body]");
      var footer = cartDrawer.querySelector("[data-cart-drawer-footer]");
      var countEl = cartDrawer.querySelector("[data-cart-drawer-count]");
      if (countEl) countEl.textContent = "(" + cart.item_count + ")";

      if (!cart.item_count) {
        body.innerHTML =
          '<div class="cart-drawer__empty">' +
            '<p class="cart-drawer__empty-title">Your cart is empty.</p>' +
            '<p class="cart-drawer__empty-sub">Time to gear up.</p>' +
            '<a class="btn btn--gold" href="/collections/shop-all">Shop all gear</a>' +
          '</div>';
        footer.hidden = true;
        return;
      }

      footer.hidden = false;

      var itemsHtml = cart.items.map(function (item, idx) {
        var line = idx + 1;
        var variantLine = (item.variant_title && item.variant_title.indexOf("Default") === -1)
          ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>' : '';
        var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, "_200x200$1$2") : "";
        return (
          '<li class="cart-drawer__item">' +
            '<a class="cart-drawer__item-media" href="' + escapeHtml(item.url) + '" tabindex="-1" aria-hidden="true">' +
              (img ? '<img src="' + escapeHtml(img) + '" alt="" width="72" height="72" loading="lazy">' : '') +
            '</a>' +
            '<div>' +
              '<a class="cart-drawer__item-title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
              variantLine +
              '<div class="cart-drawer__item-controls">' +
                '<label class="visually-hidden" for="CartDrawerQty-' + line + '">Quantity</label>' +
                '<input class="cart-drawer__item-qty" type="number" id="CartDrawerQty-' + line + '" min="0" value="' + item.quantity + '" data-cart-drawer-qty data-line="' + line + '">' +
                '<button type="button" class="cart-drawer__item-remove" data-cart-drawer-remove data-line="' + line + '">Remove</button>' +
              '</div>' +
            '</div>' +
            '<div class="cart-drawer__item-line">' + money(item.final_line_price) + '</div>' +
          '</li>'
        );
      }).join("");

      body.innerHTML = '<ul class="cart-drawer__items" role="list">' + itemsHtml + '</ul>';

      var remaining = FREE_SHIP_THRESHOLD - cart.total_price;
      var progress = Math.min(100, (cart.total_price / FREE_SHIP_THRESHOLD) * 100);
      var shipNote = cart.total_price >= FREE_SHIP_THRESHOLD
        ? "You&rsquo;ve unlocked <strong>free U.S. shipping</strong>."
        : "You&rsquo;re <strong>" + money(remaining) + "</strong> away from free U.S. shipping.";

      footer.querySelector("[data-cart-drawer-shipping]").innerHTML =
        '<p class="cart-drawer__shipping-note">' + shipNote + '</p>' +
        '<div class="cart-drawer__progress" aria-hidden="true"><span class="cart-drawer__progress-bar" style="width:' + progress + '%;"></span></div>';
      footer.querySelector("[data-cart-drawer-subtotal]").textContent = money(cart.total_price);
    }

    function fetchCart() {
      return fetch("/cart.js", { headers: { "Content-Type": "application/json" } }).then(function (r) { return r.json(); });
    }

    function refreshDrawer() {
      return fetchCart().then(renderCartDrawer);
    }

    function changeLine(line, quantity) {
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderCartDrawer(cart);
          document.dispatchEvent(new CustomEvent("cart:updated"));
        });
    }

    cartDrawer.addEventListener("click", function (e) {
      var closeTarget = e.target.closest("[data-cart-drawer-close]");
      if (closeTarget) { closeCartDrawer(); return; }

      var removeBtn = e.target.closest("[data-cart-drawer-remove]");
      if (removeBtn) { changeLine(removeBtn.getAttribute("data-line"), 0); }
    });

    cartDrawer.addEventListener("change", function (e) {
      var qtyInput = e.target.closest("[data-cart-drawer-qty]");
      if (!qtyInput) return;
      var quantity = parseInt(qtyInput.value, 10);
      if (isNaN(quantity) || quantity < 0) quantity = 0;
      changeLine(qtyInput.getAttribute("data-line"), quantity);
    });

    document.querySelectorAll("[data-cart-drawer-toggle]").forEach(function (trigger) {
      trigger.addEventListener("click", function (e) {
        e.preventDefault();
        refreshDrawer();
        openCartDrawer();
      });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && cartDrawer.getAttribute("aria-hidden") === "false") closeCartDrawer();
    });

    /* intercept product add-to-cart forms site-wide */
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.getAttribute("action") !== "/cart/add" && form.action.indexOf("/cart/add") === -1) return;

      e.preventDefault();
      var addBtnEl = form.querySelector('[name="add"]');
      var formData = new FormData(form);
      if (addBtnEl) addBtnEl.disabled = true;

      fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (addBtnEl) addBtnEl.disabled = false;
          if (!res.ok) {
            window.alert((res.data && res.data.description) || "Couldn't add that to your cart.");
            return;
          }
          refreshDrawer().then(function () {
            openCartDrawer();
            document.dispatchEvent(new CustomEvent("cart:updated"));
          });
        })
        .catch(function () {
          if (addBtnEl) addBtnEl.disabled = false;
          form.submit();
        });
    });
  }
})();
